import '../scss/style.scss';
import './lib/jquery-3.6.1.min.js';
import './lib/swiper.min.js';

// グローバル変数
// const bp = 768;
const bp = 1024;
const speed = 500;
let bodyScrollTop;
let windowHeight = window.innerHeight;

// MV
window.addEventListener("load", function() {
	const mySwiper = new Swiper('.js-hero-slider', {
		loop: true,
		speed: 2000,
		simulateTouch: false,
		shortSwipes: false,
		createPagination: false,
		longSwipes: false,
		allowTouchMove: false,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		autoplay: {
			delay: 5000,
			disableOnInteraction: false
		},
		breakpoints: {
			768: {
				autoplay: {
					delay: 8000
				}
			}
		}
	});
});

// MV
window.addEventListener("load", function() {
	const roomDetailSlider = new Swiper('.js-room-detail-slider', {
		speed: 500,
		loop: false,
		slidesPerView: 3,
		spaceBetween: 40,
		simulateTouch: false,
		shortSwipes: false,
		createPagination: false,
		longSwipes: false,
		breakpoints: {
			768: {
				// loop: true,
				slidesPerView: 1,
				simulateTouch: true,
				shortSwipes: true,
				createPagination: true,
				longSwipes: true,
				allowTouchMove: true,
				navigation: {
				  nextEl: ".js-room-detail__next",
				  prevEl: ".js-room-detail__prev",
				},
				pagination: {
					el: ".js-room-detail__pagination",
					clickable: true,
				},
			}
		}
	});
});

$(function( ) {
	// ドロワー開閉
	$("body").append('<div class="overlay">');
	$(".js-header-nav-trigger, .overlay").on("click",switchDrawer);

	if ($(".js-swipeTable")[0]) {
		$(".js-swipeTable").on("scroll", function() {
			if ($(this).hasClass("is-active")) {
				return false;
			} else {
				if (bp > window.innerWidth) {
					$(this).addClass("is-active");
				}
			}
		});
	}
});

// loading
$(window).on('load', function() {
	$('html').removeClass('is-loading');
});

// 要素がある場所に到達したらナビを表示する
$(window).on('load resize scroll', function() {
	if ($(".js-hNav-position")[0]) {
		var fixTrigger  = $(".js-hNav-position").offset().top;
		var navPosition = $(".l-header").offset().top + $(".l-header").height();
		fixSecondaryNav(fixTrigger,navPosition);
	} else {
		return false;
	}
});

// ページ内スムーススクロール
$(document).on("click", "a[href^=\"#\"]", function () {
	const spd = speed;
	const href = $(this).attr("href");
	const target = $(href == "#" || href == "" ? "html" : href);
	const position = target.offset().top;

	// スマホの時はナビを閉じる
	if (bp > window.innerWidth) {
		$("html").removeClass("is-active");
	}

	$("html, body").animate({
		scrollTop: position
	}, spd, "swing");

	return false;
});

// アニメーション
let magicnumber = 100;
$(window).on("load scroll",function (){
	$('.js-animate').each(function(){
		var targetPos  = $(this).offset().top;
		var scrollPos  = $(window).scrollTop();
		if( scrollPos > targetPos - windowHeight + magicnumber) {
			$(this).addClass('is-active');
		}
	})
});

// モーダル
$('.js-modal-img').on('click', function() {
	onScrollLock();
	var imgSrc = $(this).children().attr('src');
	$('.js-modal-image').attr('src', imgSrc);
	$('.js-modal-img-body').fadeIn();
	return false;
});
$('.js-modal-close').on('click', function() {
	$(this).parents('.js-modal').fadeOut();
	offScrollLock();
	return false;
});
$('.js-modal-img-body').on('click', function() {
	$(this).fadeOut();
	offScrollLock();
	return false;
});
$('.js-modal-image').on('click', function(e) {
	e.stopPropagation();
});

// video
$('.js-modal-video').on('click', function() {
	onScrollLock();
	$('.js-modal-video-body').fadeIn();
	videoControl("playVideo");
	return false;
});
$('.js-modal-video-body,.js-modal-video-close').on('click', function() {
	// video
	videoControl("stopVideo");
	$('.js-modal-video-body').fadeOut();
	offScrollLock();
	return false;
});

// ドロワー開閉
function switchDrawer() {
	if (window.innerWidth < bp) {
		$("html").toggleClass("is-active");
	}
}
// スクロール時、メニューが開いていたら閉じる
$(window).on("scroll", function() {
	if ($("html").hasClass("is-active")) {
		$("html").removeClass("is-active");
	}
});

// ナビ表示時、bodyのスクロールを止めて位置を記憶する。
function onScrollLock() {
	bodyScrollTop = $(window).scrollTop();
	$("body").css({top: bodyScrollTop * -1}).addClass("scrollLock");
}

function offScrollLock() {
	$("body").css({top: "auto"}).removeClass("scrollLock");
	$("html, body").prop({scrollTop: bodyScrollTop});
}

// 追従ナビ
function fixSecondaryNav(fixTrigger,navPosition) {
	var scrlTop = $(window).scrollTop();
	if (scrlTop > fixTrigger) {
		$("html").addClass("is-fixed");
	} else if (scrlTop > navPosition) {
		$("html").removeClass("is-fixed");
	} else {
		$("html").removeClass("is-fixed");
	}
}

// youtube
function videoControl(action){ 
	var $playerWindow = $('#js-ytvideo')[0].contentWindow;
	$playerWindow.postMessage('{"event":"command","func":"'+action+'","args":""}', '*');
}